import { alwaysFinite } from '../../../../common/helpers/functional';
import { PAYMENT_TYPE_LABEL } from './constants';
import { PAYMENT_TYPE } from '../../../../main/payment/constants';

const creditCardLabel = ({ cardInfo } = {}) => cardInfo && `${cardInfo.brand.toUpperCase()} **** ${cardInfo.last4}`;

const giftCardCode = code => (code ? `****${code.slice(-3)}` : '');
const giftCardLabel = payment => `${PAYMENT_TYPE_LABEL[PAYMENT_TYPE.giftCard]} ${giftCardCode(payment.code)}`;

const paymentLabel = (payment) => {
  if (payment.type === PAYMENT_TYPE.giftCard) return giftCardLabel(payment);
  if (payment.type === PAYMENT_TYPE.card) return creditCardLabel(payment);
  if (payment.type === PAYMENT_TYPE.reader) {
    return `${PAYMENT_TYPE_LABEL[payment.type]} ${creditCardLabel(payment) || ''}`;
  }

  return PAYMENT_TYPE_LABEL[payment.type];
};

// eslint-disable-next-line import/prefer-default-export
export const paymentFactory = (payment) => {
  const total = alwaysFinite(
    (payment.total + payment.tip + payment.tax) -
    (payment.refunded + payment.tipRefunded + payment.taxRefunded)
  );

  const amount = payment.amount || total;
  const tip = payment.tip - payment.tipRefunded;

  return {
    id: payment.id,
    type: payment.type,
    amount,
    tip,
    amountWithoutTip: amount - tip,
    paymentToken: payment.paymentToken,
    paymentCardId: payment.paymentCardId,
    label: paymentLabel(payment),
    code: payment.code,
    balance: payment.balance,
    cardInfo: payment.cardInfo,
    canRefund: total > 0,
    empty: payment.empty,
    applicableToBarber: payment.applicableToBarber,
  };
};

